<template>
  <hr class="horizontal" style="margin: 8px 0" v-if="showDivider" />
  <div
    class="d-flex-column justify-start align-start gap-5"
    :class="[isRecomended && 'recommeded']"
    v-if="selectedOption"
    id="boost_method"
  >
    <div class="d-flex-row space-between height-max-content">
      <div class="d-flex-row justify-start gap-5">
        <label for="" class="t-light regular-l font-family-2">
          {{ $t("path_of_exile.boost_method") }}
        </label>
        <ItemTooltip :text="$t('tooltips.boost_method')" />
      </div>
      <p class="t-green font-family-1 regular-l" v-if="isRecomended">
        {{ $t("recommended") }}
      </p>
    </div>
    <DropDown
      :drop-items="keyedPackOptions"
      :selected-item="selectedOption"
      :variant="dropdownVariant"
      :select-drop-item="selectBoostMethod"
      item-key="boost_method_dropdown"
      v-if="!$isMobile() && !$isTablet()"
    />
    <BSPicker
      v-else-if="$isMobile() || $isTablet()"
      :title="$t('path_of_exile.boost_method')"
      :show-title="false"
      :items="keyedPackOptions"
      item-key="id"
      :selected-item="selectedOption"
      :select-filter="selectBoostMethod"
      :allow-null="false"
    />
  </div>
</template>

<script setup>
import ItemTooltip from "../../fc-25/pickers/ItemTooltip.vue";
import DropDown from "~/components/custom/DropDown.vue";
import BSPicker from "../cart-pickers/BSPicker.vue";
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const { t } = useI18n();
const props = defineProps({
  keys: {
    default: ["self_play", "account_sharing", "remote_control"],
  },
  dropdownVariant: {
    default: "transparent-dark",
  },
  showRecomended: {
    default: true,
  },
  disableIds: {
    default: [],
  },
  showDivider: {
    default: true,
  },
});

const isRecomended = computed(() => {
  if (!props.showRecomended) return false;
  if (gameStore.getGamePack?.slug === "wow-mythic-dungeon-boost") {
    const ops =
      gameStore.getGamePack.pack_options?.find(
        (packOp) =>
          props.keys.includes(packOp?.const_title) &&
          !packOp?.slug &&
          checkoutStore.getPackOptions?.includes(packOp?.id)
      ) || [];
    if (ops?.const_title === "self_play") {
      return true;
    }
  }
  return false;
});

const keyedPackOptions = computed(() => {
  const gamePackOptions =
    gameStore.getGamePack.pack_options?.filter(
      (packOp) =>
        props.keys.includes(packOp?.const_title) &&
        !packOp?.slug &&
        !props.disableIds?.includes(packOp.id)
    ) || [];

  return gamePackOptions.reduce((acc, value) => {
    return {
      ...acc,
      [value.id]: `<div class='d-flex-row justify-start'>
        <p>${value.title}</p>
        ${
          value.const_title === "self_play"
            ? props.showRecomended
              ? `<span class="t-green">
         ${t("recommended")}
      </span>`
              : ""
            : ""
        }
             <span class='t-blue text-capitalize'>${renderPrice(value)}</span>
        </div>`,
    };
  }, {});
});
const packOptions = computed(() => {
  const gamePackOptions =
    gameStore.getGamePack.pack_options?.filter(
      (packOp) => props.keys.includes(packOp?.const_title) && !packOp?.slug
    ) || [];

  return gamePackOptions;
});

const isChecked = (optionId) => {
  if (checkoutStore.getPackOptions?.includes(optionId)) {
    return true;
  }
  return false;
};

const selectBoostMethod = (key, value) => {
  const option = packOptions.value.find((op) => op.id == value);
  if (!option) return;
  if (!isChecked(option.id)) {
    checkoutStore.removePackOption({
      optionIds: option?.rules?.disable || [],
    });

    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, option.id],
    });
  }
};

const selectedOption = computed(() => {
  if (checkoutStore.packOptions.length <= 0) return;

  const isselected = packOptions.value.find((op) =>
    checkoutStore.packOptions.includes(op.id)
  );
  if (!isselected) return null;
  return isselected.id;
});
</script>

<style lang="scss">
.recommeded {
  .dropdown {
    &.variant-primary {
      border: 1px solid rgba(196, 237, 79, 0.4) !important;
    }
  }
}
</style>
